import { AtlasGqlTargetBlade_External } from 'types/atlas-graphql';

export const getRotation = (target: AtlasGqlTargetBlade_External) => {
  const bladeAngle = target?.bladeAngle ?? 0;
  const radians = Number((bladeAngle || '').replace('rad', ''));
  const degrees = radians ? radians * (180 / Math.PI) : 0;

  return degrees;
};
